import { LiveEventDataSportTypes } from '@utils/formatters/liveEvent'
import { ValidSportradarGeneralStatisticsProps } from './types'

const { SOCCER, HOCKEY, TENNIS } = LiveEventDataSportTypes

const isValidSportradarGeneralStatisticsProps = (
  props: any
): props is ValidSportradarGeneralStatisticsProps =>
  !!props?.matchId && [SOCCER, HOCKEY, TENNIS].includes(props?.typeOfSport)

export { isValidSportradarGeneralStatisticsProps }
